import React from "react";
import Offices from "../Offices/Offices";
import Menu from "../Menu/Menu";
import Search from "./Search/Search";

const HeaderDesktop: React.FC = () => (
    <div className="header__bottom">
        <Menu />
        <div className="header__bottom__right">
            <Offices parentClass="header__bottom__offices" />
            <Search />
        </div>
    </div>
);

export default HeaderDesktop;